module.exports = __webpack_public_path__ + "static/img/gq.30ed019c.svg";